import yn from "yn";

// Whether the dataset Changelog (audit log) UI is enabled for this deployment.
// Read in one place so the classic Settings tab and the nextgen sidebar link
// gate identically off VITE_DATASET_AUDIT_LOG_ENABLED.
export const useAuditLogEnabled = (): boolean =>
  yn(import.meta.env.VITE_DATASET_AUDIT_LOG_ENABLED, { default: false });
